"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _gsap = _interopRequireDefault(require("gsap"));

var _styles = _interopRequireDefault(require("./styles"));

var Switch = _styles["default"].Switch,
    SwitchContainer = _styles["default"].SwitchContainer;

var _default = function _default(props) {
  var size = props.size,
      label = props.label,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      onClick = props.onClick,
      _props$width = props.width,
      width = _props$width === void 0 ? null : _props$width,
      _props$setEnabled = props.setEnabled,
      setEnabled = _props$setEnabled === void 0 ? false : _props$setEnabled;

  var _useState = (0, _react.useState)(setEnabled),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var height = null,
      compWidth = null,
      spanSize = null;

  switch (size) {
    case 'small':
      {
        height = 1.25;
        compWidth = 2.25;
        spanSize = 0.75;
        break;
      }

    case 'medium':
      {
        height = 1.5;
        compWidth = 3;
        spanSize = 1;
        break;
      }

    case 'large':
      {
        height = 2.5;
        compWidth = 10.625;
        spanSize = 2;
        break;
      }

    default:
      {
        height = 1.25;
        compWidth = 2.25;
        spanSize = 0.75;
        break;
      }
  }

  (0, _react.useEffect)(function () {
    setLoaded(true);
  }, []);
  (0, _react.useEffect)(function () {
    if (loaded) {
      _gsap["default"].to('.label', {
        opacity: 0,
        ease: true,
        duration: 0.1
      });

      _gsap["default"].to('.label', {
        opacity: 1,
        ease: true,
        duration: 0.1,
        delay: 0.25
      });
    }

    if (onClick) onClick(checked);
  }, [checked]);
  if (width) compWidth = width;
  return /*#__PURE__*/_react["default"].createElement(SwitchContainer, {
    className: "switch-container ".concat(className),
    size: size,
    width: compWidth,
    checked: checked
  }, /*#__PURE__*/_react["default"].createElement(Switch, {
    className: "switch",
    height: height,
    width: compWidth,
    spanSize: spanSize
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    onChange: function onChange() {
      return setChecked(!checked);
    },
    checked: checked
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "slider round"
  })), label && /*#__PURE__*/_react["default"].createElement("p", {
    className: "label"
  }, label));
};

exports["default"] = _default;